// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage"
import { getFirestore } from "firebase/firestore"
import { getAnalytics } from "firebase/analytics";

import { useAuthState } from 'react-firebase-hooks/auth'
import { useCollectionData } from 'react-firebase-hooks/firestore'

import { getAI, getGenerativeModel, GoogleAIBackend } from "firebase/ai";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBJQnyjGrmTyF6f2xST7nt-qmHbsF_DNjM",
  // authDomain: "marketplace-2f375.firebaseapp.com",
  authDomain: "auth.phreesh.com",
  projectId: "marketplace-2f375",
  storageBucket: "marketplace-2f375.appspot.com",
  messagingSenderId: "845159396440",
  appId: "1:845159396440:web:56d329ed381902fe26862d",
  measurementId: "G-BZ7200FVH1"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth()
export const storage = getStorage()
export const db = getFirestore()
const analytics = getAnalytics(app);

export const ai = getAI(app, { backend: new GoogleAIBackend() });
export const model = getGenerativeModel(ai, { model: "gemini-2.5-flash-lite" });
